import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import AuthData from 'types/models/AuthData';
import AppContext from 'contexts/AppContext';
import AppHeader from 'components/AppHeader';
import LoadingSpinner from 'components/LoadingSpinner';
import UserRoleType from 'types/enums/UserRoleType';

export default (): JSX.Element => {
  const [authData, setAuthData] = React.useState<AuthData | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [currentPageListNumber, setCurrentPageListNumber] = React.useState<number | null | undefined>(1);

  if (!authData) {
    const storageAuthData = localStorage.getItem('auth-data');
    if (storageAuthData) {
      setAuthData(JSON.parse(storageAuthData));
    }
  }

  const getInitRoute = () => {
    if (authData?.user?.role === UserRoleType.Admin || authData?.user?.role === UserRoleType.VenueEditor) {
      return '/private/venues';
    } else {
      return '/private/commerces';
    }
  };

  return (
    <BrowserRouter>
      <LoadingSpinner isLoading={isLoading} />
      <AppContext.Provider
        value={{ authData, setAuthData, currentPageListNumber, setCurrentPageListNumber, isLoading, setIsLoading }}
      >
        <AppHeader />
        <div className="app-container">
          <Switch>
            {/* Private Routes */}
            <Route path="/private" component={PrivateRoutes} />
            {/* Public Routes */}
            <Route path="/public" component={PublicRoutes} />
            <Redirect to={`${authData ? getInitRoute() : '/public/login'}`} />
          </Switch>
        </div>
      </AppContext.Provider>
    </BrowserRouter>
  );
};
